"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./MultiEditor.css");
require("ol/ol.css");
var antd_1 = require("antd");
var Editor_1 = __importDefault(require("../Editor/Editor"));
var TabPane = antd_1.Tabs.TabPane;
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var SymbolizerUtil_1 = __importDefault(require("../../../Util/SymbolizerUtil"));
var _isEqual = require('lodash/isEqual');
var MultiEditor = /** @class */ (function (_super) {
    __extends(MultiEditor, _super);
    function MultiEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addSymbolizer = function () {
            var _a = _this.props, onSymbolizersChange = _a.onSymbolizersChange, symbolizers = _a.symbolizers;
            var symbolizerKind = symbolizers.length > 0 ? symbolizers[0].kind : undefined;
            var newSymbolizer = SymbolizerUtil_1.default.generateSymbolizer(symbolizerKind);
            if (onSymbolizersChange) {
                onSymbolizersChange(symbolizers.concat([newSymbolizer]));
            }
        };
        _this.removeSymbolizer = function (key) {
            var _a = _this.props, onSymbolizersChange = _a.onSymbolizersChange, symbolizers = _a.symbolizers;
            var symbolizersClone = symbolizers.slice();
            symbolizersClone.splice(key, 1);
            if (onSymbolizersChange) {
                onSymbolizersChange(symbolizersClone);
            }
        };
        _this.onSymbolizerChange = function (symbolizer, key) {
            var _a = _this.props, onSymbolizersChange = _a.onSymbolizersChange, symbolizers = _a.symbolizers;
            var symbolizersClone = symbolizers.slice();
            symbolizersClone[key] = symbolizer;
            if (onSymbolizersChange) {
                onSymbolizersChange(symbolizersClone);
            }
        };
        return _this;
    }
    MultiEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    MultiEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, symbolizers = _a.symbolizers, editorProps = _a.editorProps, locale = _a.locale, internalDataDef = _a.internalDataDef, iconLibraries = _a.iconLibraries, passThroughProps = __rest(_a, ["symbolizers", "editorProps", "locale", "internalDataDef", "iconLibraries"]);
        var tabs = symbolizers.map(function (symbolizer, idx) {
            return (React.createElement(TabPane, { className: "gs-symbolizer-multi-editor-tab", key: idx.toString(), tab: idx, closable: true },
                React.createElement(Editor_1.default, __assign({ symbolizer: symbolizer, onSymbolizerChange: function (sym) {
                        _this.onSymbolizerChange(sym, idx);
                    }, internalDataDef: internalDataDef, iconLibraries: iconLibraries }, editorProps)),
                symbolizers.length === 1 ? null :
                    React.createElement(antd_1.Button, { onClick: function () {
                            _this.removeSymbolizer(idx);
                        } }, locale.remove)));
        });
        return (React.createElement(antd_1.Tabs, __assign({ className: "gs-symbolizer-multi-editor", defaultActiveKey: "0", animated: false, tabBarExtraContent: (React.createElement(antd_1.Button, { onClick: this.addSymbolizer }, locale.add)) }, passThroughProps), tabs));
    };
    MultiEditor.componentName = 'MultiEditor';
    MultiEditor.defaultProps = {
        locale: en_US_1.default.GsMultiEditor
    };
    return MultiEditor;
}(React.Component));
exports.MultiEditor = MultiEditor;
exports.default = LocaleWrapper_1.localize(MultiEditor, MultiEditor.componentName);
//# sourceMappingURL=MultiEditor.js.map